<template>
    <div id="contact">
        <div class="container_1">
            <div class="container">
                <div>
                    <p class="intro_1">{{ $t("message.contact_content1") }}</p>
                    <p class="intro_2">{{ $t("message.contact_content2") }}</p>
                    <button type="button" @click="runEstimateForm" style="position: relative">
                        <span>{{ $t("message.btn_devis") }}</span
                        ><ArrowIcon />
                    </button>
                </div>
            </div>
        </div>

        <div class="container_2">
            <div class="container">
                <div>
                    <div>
                        <LogoHaikaraWhite class="logo" />

                        <div class="list">
                            <div class="item">
                                <span class="svg">
                                    <PhoneIcon />
                                </span>
                                <span>+33 9 81 94 56 58</span>
                            </div>

                            <div class="item">
                                <span class="svg">
                                    <MailIcon />
                                </span>
                                <span>contact(at)haikara.fr</span>
                            </div>

                            <div class="item">
                                <a href="https://fr.linkedin.com/company/haikara" target="_blank" class="svg">
                                    <LinkedinIcon />
                                </a>
                                <a href="https://fr.linkedin.com/company/haikara" target="_blank">
                                    <span>haikara</span>
                                </a>
                            </div>

                            <div class="item">
                                <span class="svg">
                                    <MapIcon />
                                </span>
                                <span>61, Rue de Lyon 75012 Paris</span>
                            </div>
                        </div>
                    </div>

                    <div id="form-contact">
                        <form @submit.prevent="sendEmail">
                            <div>
                                <span class="ico">
                                    <LogoContact />
                                </span>

                                <span class="title-form">{{ $t("message.title_contact") }}</span>

                                <div class="input-group">
                                    <input type="text" v-model="name" :placeholder="$t('message.your_name_paceholder')" required class="field" />
                                </div>

                                <div class="input-group">
                                    <input type="email" v-model="email" :placeholder="$t('message.your_email_placeholder')" required class="field" />
                                </div>

                                <div class="input-group">
                                    <input type="tel" v-model="phone" :placeholder="$t('message.your_tel')" class="field" />
                                </div>

                                <div class="input-group">
                                    <textarea v-model="msg" :placeholder="$t('message.your_request')" class="field"></textarea>
                                </div>

                                <div class="input-group">
                                    <input type="hidden" name="recaptcha_response" id="recaptchaResponse" />
                                </div>

                                <div class="input-group">
                                    <div v-if="sendMailOK" id="msg-mail-ok">
                                        <IconValid color="#0093ff" />
                                        <span>{{ $t("message.send_mail_ok") }}</span>
                                    </div>

                                    <div v-if="sendMailKO" id="msg-mail-ko">
                                        <Error color="#ff0000" />
                                        <span>{{ $t("message.send_mail_ko") }}</span>
                                    </div>

                                    <button type="submit" :class="{ 'in-progress': sendMailInProgress }" :disabled="sendMailInProgress">
                                        <Spinner color="#dd0000" v-if="sendMailInProgress" style="height: 23px" />
                                        <span v-if="!sendMailInProgress">
                                            <span>{{ $t("message.to_post") }}</span>
                                            <ArrowIcon />
                                        </span>
                                    </button>
                                </div>
                            </div>

                            <div class="field-required">{{ $t("message.required_fields") }}</div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <div class="container_3">
            <div class="container">
                <div>
                    <div>
                        <div>{{ $t("message.contact_address") }}</div>
                    </div>
                    <div>
                        <div>©{{ new Date().getFullYear() }} HAIKARA</div>
                    </div>
                </div>
                <div v-html="$t('message.footer_cookie')" @click="handleClick"></div>
            </div>
        </div>

        <div v-if="showModal" class="modal-overlay">
            <div class="modal-content">
                <div v-html="$t('message.content_cookie')"></div>
                <button class="btn-close" @click="showModal = false">{{ $t("message.share_close") }}</button>
            </div>
        </div>
    </div>
</template>

<script>
import LogoHaikaraWhite from "./img/LogoHaikaraWhite.vue";
import PhoneIcon from "./img/PhoneIcon.vue";
import MailIcon from "./img/MailIcon.vue";
import MapIcon from "./img/MapIcon.vue";
import LinkedinIcon from "./img/LinkedinIcon.vue";
import LogoContact from "./img/LogoContact.vue";
import IconValid from "./img/Valid.vue";
import Spinner from "./img/Spinner.vue";
import Error from "./img/Error.vue";
import ArrowIcon from "./img/ArrowIcon.vue";

export default {
    name: "Contact",
    data() {
        return {
            name: "",
            email: "",
            phone: "",
            msg: "",
            sendMailInProgress: false,
            sendMailOK: false,
            sendMailKO: false,
            showModal: false,
        };
    },
    components: {
        LogoHaikaraWhite,
        IconValid,
        Spinner,
        Error,
        PhoneIcon,
        MailIcon,
        MapIcon,
        LinkedinIcon,
        LogoContact,
        ArrowIcon,
    },
    methods: {
        handleClick(e) {
            if (e.target.dataset.action === "cookie-more") {
                this.showModal = true;
            }
        },
        runEstimateForm() {
            this.$store.dispatch("app/displayModal", {
                display: true,
                name: "estimate",
                content: null,
            });
        },
        sendEmail() {
            let _this = this;
            this.sendMailInProgress = true;

            const fd = new FormData();
            fd.append("name", this.name);
            fd.append("email", this.email);
            fd.append("phone", this.phone);
            fd.append("msg", this.msg);

            const handleResponse = (ok) => {
                this.sendMailInProgress = false;
                this.sendMailOK = ok;
                this.sendMailKO = !ok;

                if (ok) {
                    this.name = "";
                    this.email = "";
                    this.phone = "";
                    this.msg = "";
                }

                setTimeout(() => {
                    this.sendMailOK = false;
                }, 3000);
            };

            grecaptcha.ready(() => {
                grecaptcha.execute("6Ldv7M8ZAAAAAMNQMUrYx7g4uMQ3iaQmvwAqwFiR", { action: "contact" }).then((token) => {
                    if (token) {
                        fd.append("recaptcha_response", token);

                        fetch("./contact.php", {
                            method: "POST",
                            body: fd,
                        })
                            .then((response) => {
                                console.log("Réponse HTTP reçue :", response);

                                if (!response.ok) {
                                    // Si le serveur répond 403 ou autre erreur HTTP, on gère ici
                                    throw new Error(`HTTP error! status: ${response.status}`);
                                }
                                return response.json();
                            })
                            .then((data) => {
                                if (data.success) {
                                    _this.sendMailOK = true;
                                    _this.sendMailKO = false;
                                    _this.name = _this.email = _this.phone = _this.msg = "";
                                } else {
                                    _this.sendMailOK = false;
                                    _this.sendMailKO = true;
                                }
                            })
                            .catch((error) => {
                                console.error("Erreur lors de l'envoi :", error);
                                _this.sendMailOK = false;
                                _this.sendMailKO = true;
                            });
                    } else {
                        handleResponse(false);
                    }
                });
            });
        },
    },
};
</script>

<style lang="scss">
.g-recaptcha {
    display: flex;
    justify-content: flex-end;
}

.clickable-cookie {
    text-decoration: underline;
    cursor: pointer;
}

.modal-content {
    ul {
        list-style: none;
        padding: 0;
    }
}
</style>

<style lang="scss" scoped>
#contact {
    position: relative;

    > div:not(.modal-overlay) {
        .container > div {
            max-width: 1400px;
            width: 100%;
            margin: auto;
        }

        &.container_1 {
            font-family: Oswald, sans-serif;
            background-color: #dd0000;
            color: #fff;
            padding: 2.5rem 0;
            box-sizing: border-box;

            .intro_1 {
                font-weight: 100;
                font-size: 2rem;
                text-transform: uppercase;
                margin: 0;
                width: 50%;
                padding-right: 30px;
                box-sizing: border-box;
            }

            .intro_2 {
                font-weight: 600;
                font-size: 2rem;
                text-transform: uppercase;
                margin: 0;
                width: 50%;
                padding-right: 30px;
                box-sizing: border-box;
            }

            button {
                font-family: "Oswald", sans-serif;
                color: #dd0000;
                text-transform: uppercase;
                font-size: 1.2rem;
                border: 0;
                outline: none;
                background-color: #fff;
                border-radius: 20px;
                width: auto;
                transition: 0.5s;
                font-weight: 600;
                cursor: pointer;
                padding: 0.5rem 1rem;
                box-sizing: border-box;
                display: flex;
                align-items: center;
                justify-content: center;
                box-shadow: 0 0 0;
                border: 1px solid #fff;
                margin-top: 2rem;

                svg {
                    fill: #dd0000;
                    width: 30px;
                    margin-left: 0.6rem;
                }
            }
        }

        &.container_2 {
            background-color: #fe0000;
            color: #fff;

            > div {
                > div {
                    display: flex;
                    flex-flow: row nowrap;

                    > div {
                        flex: 1;
                    }

                    #form-contact {
                        position: relative;
                    }

                    form {
                        position: absolute;
                        top: -320px;
                        right: 0;
                        width: 100%;

                        > div:not(.field-required) {
                            background-color: #fff;
                            padding: 2rem 3rem;
                            box-sizing: border-box;
                            border-radius: 15px;
                            position: relative;
                        }

                        .field-required {
                            margin-left: 3rem;
                            margin-top: 0.5rem;
                            font-family: "Roboto", sans-serif;
                            font-weight: 100;
                            font-style: italic;
                        }

                        &:before {
                            content: "";
                            display: block;
                            background-color: rgb(0, 0, 0, 0.1);
                            position: absolute;
                            top: 50px;
                            left: 8px;
                            transform: rotate(5deg);
                            width: 100%;
                            height: 90%;
                            border-radius: 15px;
                        }

                        .title-form {
                            font-family: Oswald, sans-serif;
                            text-transform: uppercase;
                            font-weight: 600;
                            font-size: 2rem;
                            padding: 0 0 1rem;
                            display: block;
                            box-sizing: border-box;
                            color: #f90000;
                        }

                        .field {
                            border-radius: 30px;
                            border: 0;
                            font-size: 1.2rem;
                            padding: 0.6rem 1rem;
                            box-sizing: border-box;
                            width: 100%;
                            transition: 0.4s;
                            font-family: "Roboto", sans-serif;
                            background: rgba(255, 255, 255, 0.85);
                            border: 1px solid #ddd;
                            box-shadow: 0 0 0;

                            &:focus {
                                border-color: #636363;
                            }
                        }

                        textarea {
                            resize: none;
                            height: 250px;
                        }

                        .input-group {
                            position: relative;
                            margin-bottom: 0.7rem;
                            text-align: right;

                            &:last-child {
                                position: relative;
                                margin: 0;
                            }
                        }

                        .ico {
                            position: absolute;
                            top: -60px;
                            right: 2rem;

                            svg {
                                width: 120px;
                                height: auto;
                            }
                        }

                        button {
                            font-family: "Roboto", sans-serif;
                            color: #dd0000;
                            text-transform: uppercase;
                            font-size: 1.2rem;
                            border: 0;
                            outline: none;
                            background-color: #fff;
                            border-radius: 20px;
                            width: auto;
                            transition: 0.5s;
                            font-weight: 600;
                            cursor: pointer;
                            padding: 0.7rem 2rem;
                            box-sizing: border-box;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            box-shadow: 0 0 0;
                            border: 1px solid #dd0000;
                            margin-top: 1rem;
                            width: 192px;

                            svg {
                                fill: #dd0000;
                                width: 30px;
                                margin-left: 0.6rem;
                            }

                            &:disabled {
                                cursor: not-allowed;
                                opacity: 0.6;
                            }
                        }
                    }
                }
            }

            .logo {
                width: 250px;
                margin: 2rem 0;
            }

            .list {
                display: flex;
                flex-flow: column;
                padding-bottom: 2rem;

                .item {
                    font-family: "Roboto", sans-serif;
                    font-weight: 100;
                    display: flex;
                    flex-flow: row nowrap;
                    align-items: center;
                    color: #fff;
                    font-size: 1.2rem;
                    text-decoration: none;
                    margin-bottom: 1.4rem;

                    a {
                        text-decoration: none;
                        color: #fff;
                        font-family: "Roboto", sans-serif;
                        font-weight: 100;
                        font-size: 1.2rem;
                    }
                }
            }

            .svg {
                display: inline-flex;
                align-items: flex-end;
                justify-content: center;
                height: 40px;
                width: 40px;
                margin-right: 1rem;

                svg {
                    width: auto;
                    height: 100%;
                }
            }
        }

        &.container_3 {
            background-color: #dd0000;
            color: #fff;
            padding: 0.5rem 0;
            font-family: "Roboto", sans-serif;
            font-weight: 100;
            font-size: 1rem;

            > div > div:first-child {
                display: flex;
                flex-flow: row nowrap;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 0.5rem;
            }
        }
    }
}

#msg-mail-ko,
#msg-mail-ok {
    background-color: #f5f5f5;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: flex-start;
    z-index: 1;

    svg {
        height: auto;
        width: 4rem;
        margin-right: 1rem;
    }

    span {
        font-size: 1.2rem;
        color: #707070;
        font-weight: 700;
    }
}

:focus {
    outline: none;
}

// Modal de partage
.modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10000;
    padding: 1rem;
}

.modal-content {
    background-color: #0e3077;
    color: #fff;
    padding: 2rem;
    border-radius: 10px;
    width: 100%;
    max-width: 700px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
    font-family: "Roboto", sans-serif;
    text-align: center;

    .btn-close {
        padding: 0.5rem 1.2rem;
        margin: 0.3rem 0.3rem 0;
        border: none;
        border-radius: 5px;
        background-color: #00d5ff;
        color: #000;
        font-weight: bold;
        font-family: "Roboto", sans-serif;
        cursor: pointer;
        transition: background-color 0.3s;
        font-size: 1rem;

        &:hover {
            background-color: #00b5dd;
        }
    }
}

@media (max-width: 1500px) {
    #contact {
        > div:not(.modal-overlay) {
            &.container_2 {
                > div {
                    > div {
                        form {
                            &:before {
                                top: 60px;
                                left: 4px;
                                transform: rotate(2deg);
                            }
                        }
                    }
                }
            }
        }
    }
}

@media (max-width: 1400px) {
    #contact {
        > div:not(.modal-overlay) {
            &.container_1 {
                padding: 2rem 0;

                .intro_1 {
                    font-size: 1.8rem;
                }

                .intro_2 {
                    font-size: 1.8rem;
                }

                button {
                    font-size: 1.2rem;
                    padding: 0.5rem 1rem;
                    margin-top: 1.6rem;
                }
            }

            &.container_2 {
                > div {
                    > div {
                        form {
                            top: -300px;

                            &:before {
                                top: 60px;
                                left: 4px;
                                transform: rotate(2deg);
                                width: 100%;
                                height: 85%;
                            }

                            > div:not(.field-required) {
                                padding: 1rem 2rem;
                            }

                            .field-required {
                                margin-left: 3rem;
                                margin-top: 0.5rem;
                            }

                            .title-form {
                                font-size: 1.8rem;
                                padding: 0 0 1rem;
                            }

                            .field {
                                font-size: 1.1rem;
                                padding: 0.6rem 0.9rem;
                            }

                            textarea {
                                height: 250px;
                            }

                            .input-group {
                                margin-bottom: 0.7rem;
                            }

                            .ico {
                                top: -50px;
                                right: 1rem;

                                svg {
                                    width: 100px;
                                }
                            }

                            button {
                                font-size: 1.1rem;
                                padding: 0.7rem 2rem;
                                margin-top: 0.8rem;

                                svg {
                                    width: 30px;
                                    margin-left: 0.6rem;
                                }
                            }
                        }
                    }
                }

                .logo {
                    width: 230px;
                    margin: 1.4rem 0;
                }

                .list {
                    padding-bottom: 1.4rem;

                    .item {
                        font-size: 1.1rem;
                        margin-bottom: 1.2rem;

                        a {
                            font-size: 1.1rem;
                        }
                    }
                }

                .svg {
                    height: 36px;
                    width: 36px;
                }
            }

            &.container_3 {
                padding: 0.4rem 0;
                font-size: 1rem;
            }
        }
    }
}

@media (max-width: 1200px) {
    #contact {
        > div:not(.modal-overlay) {
            &.container_2 {
                > div {
                    > div {
                        form {
                            top: -300px;

                            &:before {
                                top: 60px;
                                left: 4px;
                                transform: rotate(2deg);
                                width: 100%;
                                height: 85%;
                            }
                        }
                    }
                }

                .logo {
                    width: 230px;
                    margin: 1.4rem 0;
                }

                .list {
                    padding-bottom: 1.4rem;

                    .item {
                        font-size: 1.1rem;
                        margin-bottom: 1.2rem;

                        a {
                            font-size: 1.1rem;
                        }
                    }
                }

                .svg {
                    height: 36px;
                    width: 36px;
                }
            }

            &.container_3 {
                padding: 0.4rem 0;
                font-size: 1rem;
            }
        }
    }
}

@media (max-width: 992px) {
    #contact {
        > div:not(.modal-overlay) {
            &.container_1 {
                padding: 1.6rem 0;

                .intro_1 {
                    width: 100%;
                    font-size: 1.6rem;
                }

                .intro_2 {
                    width: 100%;
                    font-size: 1.6rem;
                }

                button {
                    font-size: 1.1rem;
                    padding: 0.5rem 1rem;
                    margin-top: 1.1rem;
                }
            }

            &.container_2 {
                > div {
                    > div {
                        #form-contact {
                            flex: 0 0 60%;
                            padding: 2rem 0;
                        }

                        form {
                            position: static;

                            &:before {
                                top: 60px;
                                left: 4px;
                                transform: rotate(2deg);
                                width: 100%;
                                height: 85%;
                            }
                        }
                    }
                }

                .logo {
                    width: 230px;
                    margin: 1.4rem 0;
                }

                .list {
                    padding-bottom: 1.2rem;

                    .item {
                        font-size: 1rem;
                        margin-bottom: 1rem;

                        a {
                            font-size: 1rem;
                        }
                    }
                }

                .svg {
                    height: 30px;
                    width: 30px;
                }
            }

            &.container_3 {
                padding: 0.4rem 0;
                font-size: 0.9rem;
            }
        }
    }
}

@media (max-width: 768px) {
    #contact {
        > div:not(.modal-overlay) {
            &.container_1 {
                padding: 1rem 0 1.2rem;

                .intro_1 {
                    width: 100%;
                    font-size: 1.4rem;
                }

                .intro_2 {
                    width: 100%;
                    font-size: 1.4rem;
                }

                button {
                    font-size: 1rem;
                    padding: 0.5rem 1rem;
                    margin-top: 1rem;
                }
            }

            &.container_2 {
                > div {
                    > div {
                        flex-flow: column;

                        #form-contact {
                            flex: 1;
                            padding: 3rem 0 1rem;
                            order: -1;
                        }

                        form {
                            position: static;

                            &:before {
                                content: none;
                            }

                            > div:not(.field-required) {
                                padding: 1rem;
                            }

                            .field-required {
                                margin-left: 1rem;
                                margin-top: 0.5rem;
                            }

                            .title-form {
                                font-size: 1.4rem;
                                padding: 0 0 0.5rem;
                            }

                            .field {
                                font-size: 1rem;
                                padding: 0.6rem 0.9rem;
                            }

                            textarea {
                                height: 200px;
                            }

                            .input-group {
                                margin-bottom: 0.5rem;
                            }

                            .ico {
                                top: -40px;
                                right: 1rem;

                                svg {
                                    width: 80px;
                                }
                            }

                            button {
                                font-size: 1rem;
                                padding: 0.5rem 2rem;
                                margin-top: 0.5rem;

                                svg {
                                    width: 30px;
                                    margin-left: 0.6rem;
                                }
                            }
                        }
                    }
                }

                .logo {
                    width: 200px;
                    margin: 1rem 0;
                }

                .list {
                    padding-bottom: 1rem;

                    .item {
                        font-size: 1rem;
                        margin-bottom: 1rem;

                        a {
                            font-size: 1rem;
                        }
                    }
                }

                .svg {
                    height: 30px;
                    width: 30px;
                }
            }

            &.container_3 {
                padding: 0.4rem 0;
                font-size: 0.9rem;

                > div > div:first-child {
                    display: flex;
                    flex-flow: column;
                    align-items: center;
                    justify-content: space-between;
                    margin-bottom: 1rem;
                }
            }
        }
    }
}
</style>
